import type { ActionCreator, Actions, State, ThunkCreator } from 'easy-peasy';
import type { StoreModel } from '@app/store/types/store-model';
import type {
  TGetContractPayload,
  TContractStore,
  TSignedContractData,
} from '@model/Contract/Contract.type';
import { CONTRACT_SERVICE_TYPES } from '@model/Contract/Contract.constants';

/**
 * Selectors
 */
export const contractStoreStateSelector = (
  state: State<StoreModel>,
): TContractStore['data'] => state.contract.data;

export const signedContractDataSelector = (
  state: State<StoreModel>,
): TSignedContractData | null => state.contract.signedContractData;

export const selectorContractIsReverseMarketing = (
  state: State<StoreModel>,
): boolean =>
  state.contract.data?.serviceType === CONTRACT_SERVICE_TYPES.REVERSE_MARKETING;

/**
 * Actions and Thunk selectors
 */
export const getSignedContractSelector = (
  actions: Actions<StoreModel>,
): ThunkCreator<TGetContractPayload, TSignedContractData> =>
  actions.contract.getSignedContract;

export const setSignedContractDataSelector = (
  actions: Actions<StoreModel>,
): ActionCreator<TSignedContractData> => actions.contract.setSignedContractData;
